import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'
import { get } from 'lodash'

const ExportErroModalAvaliacao = ( { open, handleClose, data } ) => {
  return (
    <div>
      <Dialog open={open} onClose={open}>
        <DialogTitle>Encontrado alguns erros</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {Object.keys(data).map(obj => (
              <>
                <span style={{ fontSize: "26px" }}>{obj.charAt(0).toUpperCase() + obj.slice(1)}:</span>
                {get(data, `${[obj]}`, []).map((dt, i) => (
                  <div style={{display: 'flex', flexDirection: 'column'}}>
                    <span style={{display: 'flex', flexDirection: 'column', fontSize: "16px" }}>{obj === 'items' ? `Item ${i + 1}` : `Erros: ${i + 1}`}</span>
                    {Object.keys(dt).length === 0 ? <span>Este item não possui erros.</span> : Object.keys(dt).map((key) => (
                      <span>{key === 'position' ? 'A posição do item não pode ser nula.' : key === 'value' ? 'O valor do item também não pode ser nulo.' : `O campo ${key} possui algum campo não identificado.`}</span>
                    ))}
                  </div>
                ))}
              </>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ExportErroModalAvaliacao
